export {default as urls} from "./urls"
export {default as routes} from "./routes"
export {default as vars} from "./vars"
export {default as persistConfig} from "./redux-persist"



// WEBPACK FOOTER //
// ./src/config/index.js